<template>
  <base-content>
    <template v-slot:top>
      <hero-header heading="Project Manager">
        <base-button modal="#createProjectModal" icon-right="plus" secondary>
          Create New Project
        </base-button>

        <create-project-modal />
      </hero-header>
    </template>

    <project-filter />
  </base-content>
</template>

<script>
import CreateProjectModal from '@/components/CreateProjectModal.vue'
import HeroHeader from '@/components/HeroHeader.vue'
import ProjectFilter from '@/components/ProjectFilter.vue'

export default {
  components: {
    CreateProjectModal,
    HeroHeader,
    ProjectFilter
  }
}
</script>
